<template>
    <modal
      name="add-on-sale"
      transition="nice-modal-fade"
      height="auto"
      :maxWidth="680"
      width="90%"
      :adaptive="true"
      :top="50"
      :delay="100"
    >
      <div class="modal-container">
        <div>
          <h3>Noe ekstra til maten?</h3>
          <div class="shine"></div>
          <a-list>
            <a-row type="flex" justify="center">
              <a-col >
                <a-list-item v-for="item in products">

                  <a-list-item-meta>
                    <a-avatar
                    slot="avatar"
                    :src="item.imageUrl"
                    />
                    
                  </a-list-item-meta>
                  <a-space :size="10">
                    <span>{{ item.itemName }}</span>
                    <span>
                      {{ item.itemPrice }}kr
                    </span>
                    <span slot="actions">
                      <a-button @click="handleBtnAddToCart(item)" type="dashed" shape="circle" icon="plus" />
                    </span>
                  </a-space>

                </a-list-item>
              </a-col>
            </a-row>
          </a-list>
        </div>
        <button @click="$modal.hide('add-on-sale')" class="blk-btn-modal">
          Nei takk
        </button>
      </div>
    </modal>
  </template>
  
<script>
  export default {
    name: "AddOnSale",
    props: {
        products: { type: Array }
    },
    data() {
      return {
      };
    },
    computed: {},
  
    methods: {
      handleBtnAddToCart(product) {
        let item = {
          itemId: product.itemId,
          itemName: product.itemName,
          itemPrice: product.itemPrice,
          categoryName: product.categoryName,
          tax: product.tax,
          discount: product.discount,
          options: [],
          isCustomized: false,
          addedPrice: 0.0,
          estimatedTime: product.estimatedTime,
          quantity: 1,
          groupOptionsModel: [],
          comment: null,
          imageUrl: product.imageUrl
        };
      // console.log(item)
        this.$store.commit("cart/ADD_ITEM_STATE", { item: item });
        this.$store.commit('cart/UPDATE_ESTIMATED_TIME_STATE', {}); 
        this.openAddToCartNotificationEvent();
      },
      openAddToCartNotificationEvent() {
        this.$notification.open({
          message: "Item is added to the cart",
          duration: 1,
          icon: <a-icon type="shopping-cart" />
        });
      }
    }
  };
</script>
  
<style lang="scss" scoped>
  $desktop: 1200px;
  $laptop: 1024px;
  $tablet: 768px;
  $mobile: 480px;
  
  
  .modal-container {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  
  .close-button {
    position: absolute;
    top: 0%;
    right: 0;
  }
  
  .position-close {
    position: absolute;
    top: 0%;
    right: 0;
    font-size: 28px;
  }

  </style>
